<script lang="ts">
  import { onDestroy } from "svelte"

  type OrgUsageRow = {
    id: number
    name: string
    tokens: number
    cost_cents: number
    users: number
  }

  let { rows = [] }: { rows: OrgUsageRow[] } = $props()

  const maxTokens = $derived(Math.max(1, ...rows.map((row) => row.tokens || 0)))

  const formatTokens = (value: number) => new Intl.NumberFormat("ko-KR").format(value)

  onDestroy(() => {
  })
</script>

<div class="space-y-4">
  {#if rows.length > 0}
    {#each rows as row (row.id)}
      <div class="grid gap-3 md:grid-cols-[180px_1fr_96px] md:items-center">
        <div>
          <p class="text-sm font-medium text-[#171A20]">{row.name}</p>
          <p class="mt-1 text-xs text-[#5C5E62]">사용자 {formatTokens(row.users)}명</p>
        </div>
        <div class="h-3 overflow-hidden rounded-[4px] bg-[#EEEEEE]" aria-label={`${row.name} 이번 달 토큰 ${formatTokens(row.tokens)}`}>
          <div class="h-full rounded-[4px] bg-[#3E6AE1]" style={`width: ${Math.max(2, (row.tokens / maxTokens) * 100)}%;`}></div>
        </div>
        <p class="text-right text-sm font-medium text-[#171A20]">{formatTokens(row.tokens)}</p>
      </div>
    {/each}
  {:else}
    <p class="text-sm text-[#5C5E62]">아직 표시할 조직 사용량이 없습니다.</p>
  {/if}
</div>
